<template>
  <div class="message">
    <div class="icon">
      <img :src="icon" />
    </div>
    <div class="content">
      <div class="title">
        {{ message.title }}
      </div>
      <div class="text">
        {{ message.text }}
      </div>
      <div class="inline-preferences" v-if="message.inline_preference">
        <checkbox title="" :value="true" />
        <span class="opt-in-text">{{ message.inline_preference.opt_in }}</span>
        <el-row style="text-align: center">
          <el-col>
            <el-button type="primary">{{
              message.inline_preference.button
            }}</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImageIcon from '@/img/upload-image.png'

export default {
  name: 'OnsiteMessagePreview',
  props: {
    message: Object
  },
  computed: {
    icon: function() {
      if (this.message.icon) {
        return this.message.icon
      } else {
        return UploadImageIcon
      }
    }
  }
}
</script>

<style scoped>
.message {
  box-shadow: 0 0 6px #888888;
  background: #ffffff;
  font-family: 'Trebuchet MS', 'Helvetica', sans-serif;
  cursor: default;
  position: relative;
  display: flex;
  padding: 10px;
}
.icon {
  display: block;
  margin-right: 15px;
  width: 80px;
}
.icon img {
  width: 80px;
  height: 80px;
}
.content {
  flex: 1;
}
.title {
  font-size: 14px;
  line-height: 20px;
  color: #444444;
}
.text {
  font-size: 13px;
  line-height: 18px;
  color: #666666;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/onsite/OnsiteMessagePreview.vue